module.exports = __webpack_public_path__ + "img/news-05.60dbb3c2.jpg";